<template>
  <div class="container">
    <!-- 头图 -->
    <div class="headerBg">
      <v-header></v-header>
    </div>

    <div class="main">
      <v-main />
    </div>


  </div>
</template>

<script>
import vHeader from "../view/header.vue";
import vMain from "../view/main.vue";

export default {
  name: "Index",
  components: {
    vHeader,
    vMain
  }
};
</script>

<style lang="scss" scoped>
.container{
   background-color: #464134;
  //background: url("~@/assets/lenovoAi/pc/banner.jpg");
  width: 100%;
  height: 100%;
}

.main{
  position: relative;

}
.img-3{
  position: absolute;
  bottom: -100px;

  img{
    width: 546px;
    height: 395px;
  }
}
</style>